import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAuthError,
  getAuthIsAuthenticating,
  getHasFetchedBookingAuthMethod,
  getAuthMethod,
  getIsSSOAuth,
  isAuthenticatedUser,
  isAuthenticatedWithSSO,
  getIsAuthenticatedWithGatekeeper,
} from 'store/authentication/selectors';
import { getSsoInitializationState } from 'store/authentication/sso/selectors';
import { createSBAAuthentication, removeSBAAuthentication } from 'store/authentication/sba/actions';
import { retrieveBookingAuthMethod, setAuthToSSO } from 'store/authentication/actions';

export const mapStateToProps = (state) => {
  return {
    isSSO: getIsSSOAuth(state),
    hasFetchedBookingAuthMethod: getHasFetchedBookingAuthMethod(state),
    authMethod: getAuthMethod(state),
    isAuthenticating: getAuthIsAuthenticating(state),
    isAuthenticated: isAuthenticatedUser(state),
    authError: getAuthError(state),
    isAuthenticatedWithSSO: isAuthenticatedWithSSO(state),
    isAuthenticatedWithGatekeeper: getIsAuthenticatedWithGatekeeper(state),
    hasInitializedSSO: getSsoInitializationState(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createAuthentication: createSBAAuthentication,
      removeAuthentication: removeSBAAuthentication,
      retrieveBookingAuthMethod,
      setAuthToSSO,
    },
    dispatch,
  );

const withAuthentication = connect(mapStateToProps, mapDispatchToProps);

export default withAuthentication;
